<template>
    <img :src="imgSrc" :alt="alt" />
</template>

<script>
    // to use it just provide src with path relative to src/assets/ folder
    // e.g. icons/arrow.svg
    // this is for require.context() needs literal path, not const or variable
    export default {
        name: 'AssetsImg',
        props: {
            assetPath: String,
            alt: String,
        },
        data: function () {
            const assetsContext = require.context('../assets/', true);
            return {
                context: assetsContext,
            };
        },
        computed: {
            imgSrc: function () {
                return this.context('./' + this.assetPath);
            },
        },
    };
</script>
